<div
    *ngIf="!prominenceStatus || prominenceStatus === prominenceJobStatuses.DONE"
    [id]="id + '.' + filter.id"
    class="agpr-prominenceFilter"
>
    <agpr-filter-include-exclude
        *ngIf="filter.showIncludeExclude"
        [(ngModel)]="filter.currentIncludeExclude"
        (ngModelChange)="currentIncludeExcludeChange()"
    ></agpr-filter-include-exclude>
    <label
        class="agpr-prominenceFilter-search"
    >
        <agpr-text-input
            [id]="id + '.' + filter.id + '.search'"
            icon="fa-regular fa-duotone fa-magnifying-glass"
            [(ngModel)]="searchQuery"
            (ngModelChange)="search()"
            ariaLabel="Monitor.filter.prominence.add"
        ></agpr-text-input>
    </label>
    <div class="agpr-prominenceFilter-toggleContainer">
        <!-- Probably makes no sense for prominence (selecting all is equivalent to selecting nothing) -->
        <!--a
            *ngIf="!anyOptionsSelected && filteredOptions.length > 0"
            [id]="id + '.' + filter.id + '.selectAll'"
            class="agpr-prominenceFilter-allToggle"
            (click)="selectAll()"
        >
            {{ 'selectAll' | localize }}
        </a-->
        <agpr-button
            *ngIf="anyOptionsSelected && filteredOptions.length > 0"
            [id]="id + '.' + filter.id + '.selectNone'"
            class="agpr-prominenceFilter-allToggle"
            [style]="buttonTypes.link"
            (click)="selectNone()"
            [label]="'selectNone' | localize"
        >
        </agpr-button>
    </div>
    <agpr-scroll-panel>
        <div class="agpr-prominenceFilter-noContent" *ngIf="filteredOptions.length < 1">
            <agpr-message
                class="agpr-leftSidebar-noItemsMessage"
                [severity]="severity.noContent"
            >{{ 'Common.filter.noContent' | localize }}
            </agpr-message>
        </div>
        <div
            *ngFor="let option of filteredOptions; let i = index"
            class="agpr-prominenceFilter-groups"
        >
            <button
                class="agpr-prominenceFilter-groups-toggle"
                [attr.aria-expanded]="expanded[option.label]"
                (click)="toggleFilterExpansion(option)"
            >
                <span
                    class="fa agpr-prominenceFilter-caret"
                    [ngClass]="expanded[option.label] ? 'fa-solid fa-angle-down' : 'fa-solid fa-angle-right'"
                    aria-hidden="true"
                ></span>
                <span>{{ option.label }}</span>
            </button>

            <ng-container *ngIf="expanded[option.label]">
                <ul
                    class="agpr-prominenceFilter-list"
                    [attr.aria-label]="option.label"
                >
                    <li
                        *ngFor="let checkbox of option.checkboxes; let j = index"
                        class="agpr-prominenceFilter-listItem"
                    >
                        <agpr-checkbox
                            [id]="'prominenceFilter_' + i + '_checkbox_' + j"
                            class="agpr-prominenceFilter-checkbox"
                            [name]="'prominenceFilter-' + filter.id"
                            [value]="option.id + '-' + option.label + '-' + checkbox.value"
                            [label]="checkbox.label"
                            [(ngModel)]="value"
                            (ngModelChange)="handleChange()"
                        >
                            <span
                                *ngIf="(checkbox.count || checkbox.count === 0) && !filter.hideFacet"
                                class="agpr-prominenceFilter-itemCount"
                                [pTooltip]="checkbox.count | number"
                            >
                                {{ checkbox.count | significantDigits : 1}}
                            </span>
                        </agpr-checkbox>
                    </li>
                </ul>
            </ng-container>
        </div>
    </agpr-scroll-panel>
</div>
<div
    *ngIf="!!prominenceStatus && prominenceStatus !== prominenceJobStatuses.DONE"
    class="agpr-prominenceFilter-message"
>
    <agpr-message
        *ngIf="prominenceStatus === prominenceJobStatuses.PENDING || prominenceStatus === prominenceJobStatuses.ONGOING"
        [severity]="severity.warning"
    >
        {{ 'AccountPreferences.prominence.disclaimer.cannotEdit' | localize }}
    </agpr-message>
    <agpr-message
        *ngIf="prominenceStatus === prominenceJobStatuses.FAILED"
        [severity]="severity.error"
    >
        {{ 'AccountPreferences.prominence.disclaimer.contactEngineering' | localize }}
    </agpr-message>
</div>
